import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'columnTranslate',
  pure: false // Set to false so it updates immediately when language changes
})
export class ColumnTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(column: string, fallback?: string): string {
    if (!column) return '';

    const key = column.toUpperCase();
    const translation = this.translate.instant(key);

    // If the service returns the key itself, the translation was not found.
    // In that case, we return the original column name (e.g., "status")
    return translation === key ? fallback!.charAt(0).toUpperCase() + fallback!.slice(1).toLowerCase() : translation;
  }
}